import * as Yup from 'yup';
import { metadataValidationShape } from '../format-template-metadata.validation';

export const validationSchema = Yup.object().shape(metadataValidationShape);
